module.exports = __webpack_public_path__ + "static/media/company.a4dc02e5.webp";